// extracted by mini-css-extract-plugin
export var askAiIcon = "_me-9";
export var container = "_me-0";
export var groupSeparator = "_me-a";
export var highlight = "_me-4";
export var resultIcon = "_me-5";
export var resultItem = "_me-7";
export var resultSubtitle = "_me-3";
export var resultTitle = "_me-2";
export var resultsList = "_me-1";
export var searchGroup = "_me-6";
export var selected = "_me-8";